<app-crud-view [data]="dataFetch" [columnNames]="columnNames"></app-crud-view>
